import script from "./GrammarAnswerReviewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GrammarAnswerReviewModal.vue?vue&type=script&setup=true&lang=ts"

import "./GrammarAnswerReviewModal.vue?vue&type=style&index=0&id=07ab6245&scoped=true&lang=scss"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ab6245"]])

export default __exports__